import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './AvatarStyles.scss';
import ImageService from '../../services/ImageService';

export default class Avatar extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    shape: PropTypes.string,
    onClick: PropTypes.func,
    size: PropTypes.number,
    placeholderIcon: PropTypes.string,
    placeholderIconSize: PropTypes.number,
    placeholderIconColor: PropTypes.string,
  };

  static defaultProps = {
    user: null,
    shape: null,
    handleClick: null,
    size: 40,
    placeholderIcon: null,
    placeholderIconSize: null,
    placeholderIconColor: null,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  sizedImageOptions = {
    w: this.props.size,
    h: this.props.size,
  };
  imageServiceOptions = Object.assign(
    { dpr: window.devicePixelRatio, usm: 15 },
    this.sizedImageOptions,
    {
      fit: 'crop',
    },
  );

  isUserImage = source => {
    return (
      source.attachment_type &&
      (source.attachment_type.toUpperCase() === 'USER' ||
        source.attachment_type.toUpperCase() === 'USER_CONTACT')
    );
  };

  isBusinessImage = source => {
    return (
      source.attachment_type &&
      (source.attachment_type.toUpperCase() === 'BUSINESS' ||
        source.attachment_type.toUpperCase() === 'BUSINESS_CONTACT')
    );
  };

  isPropertyImage = source => {
    return (
      source.attachment_type &&
      source.attachment_type.toUpperCase().includes('PROPERTY')
    );
  };

  getPlaceholderIcon = () => {
    const { user, placeholderIcon } = this.props;

    if (placeholderIcon) {
      return placeholderIcon;
    }

    if (this.isPropertyImage(user)) {
      return 'home';
    } else if (this.isBusinessImage(user)) {
      return 'business';
    } else if (this.isUserImage(user)) {
      return 'person';
    } else {
      return 'person';
    }
  };

  isSquareAvatar = () => {
    let displayShape =
      this.props.shape ||
      (this.isUserImage(this.props.user) ? 'CIRCLE' : 'SQUARE');
    return displayShape === 'SQUARE';
  };

  render() {
    const {
      user,
      size,
      handleClick,
      placeholderIconSize,
      placeholderIconColor,
    } = this.props;
    const avatarImage = ImageService().getFull(
      user.image,
      this.imageServiceOptions,
    );
    return (
      <div
        className={`${
          styles.avatarContainer
        } layout--row layout-align--center-center`}
        style={{
          width: size,
          height: size,
          borderRadius: this.isSquareAvatar() ? 2 : '50%',
          cursor: handleClick ? 'pointer' : 'normal',
        }}
        onClick={handleClick}
      >
        {user.image ? (
          <img src={avatarImage} width={this.size} height={this.size} />
        ) : (
          <span
            className={`icon qm-icon-${this.getPlaceholderIcon()} ${
              styles.avatarPlaceholder
            }`}
            style={{
              fontSize: placeholderIconSize || size * 0.7,
              lineHeight: (placeholderIconSize || size * 0.7) + 'px',
              height: placeholderIconSize || size * 0.7,
              color: placeholderIconColor,
            }}
          />
        )}
      </div>
    );
  }
}
